import { Pagination } from "antd";
import { Link } from "react-router-dom"
import Loadar from "../../../common/loader/Loader";
import ExportPdf from "../../../common/exportPdf/ExportPdf";
import { CSVLink } from "react-csv";
import Breadcrumbs from "../../../common/breadcrumb/Breadcrumbs";
import { useState } from "react";
import { CiSaveUp1, CiSaveDown1 } from 'react-icons/ci'; // Assuming these are the correct icons
import { Button } from "react-bootstrap";


function WalletsReportsList({page, apes=false, downloadExcel, excelLoader, data, onChangeVal, totalCount, loading }) {

    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");


    // Sorting function
    const handleSort = (column) => {
        const newOrder = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
        setSortColumn(column);
        setSortOrder(newOrder);
    };

    // Sort data based on selected column
    const sortedData = data?.sort((a, b) => {
        if (!sortColumn) return 0;
        const aValue = a[sortColumn] || "";
        const bValue = b[sortColumn] || "";
        return sortOrder === "asc"
            ? aValue.toString().localeCompare(bValue.toString())
            : bValue.toString().localeCompare(aValue.toString());
    });


  

    return (
        <>
            {/* <Breadcrumbs breadCrumbsTitle={""} /> */}
            {loading && <Loadar />}
            <section className="ListDistributer exppdf">
                <div className="row m-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1">
                                    <div className="tbl-caption">
                                        <h4 className="heading mb-0"><b>All Wallets Reports List</b></h4>
                                        <div>
                                            {/* <Link className="btn btn-primary btn-sm" to="/admin/add-wallets/report" role="button" aria-controls="offcanvasExample">+ ADD  Wallets  </Link> */}
                                            {/* <button type="button" className="btn btn-secondary btn-sm" >
                                        + Invite Employee
                                    </button> */}
                                            {/* <ExportPdf /> */}

                                            <Button variant="" className="btn-sm py-1 px-2 bg-success" 
                                            onClick={downloadExcel} disabled={excelLoader}
                                            >
                {excelLoader ? (
                    <span>
                        <CiSaveUp1 className='fs-4 fw-bold text-white'/> Excel Downloading...
                    </span>
                ) : (
                    <span>
                      Download Excel <CiSaveDown1 className='fs-4 fw-bold  text-white' />
                    </span>
                )}
            </Button>
                                            {/* <CSVLink  className="btn btn-succes" data={data}>Export Excel</CSVLink> */}
                                        </div>
                                    </div>
                                    <div id="empoloyees-tblwrapper_wrapper" className="dataTables_wrapper no-footer">
                                        {/* <div className="dt-buttons"><button className="dt-button buttons-excel buttons-html5 btn btn-sm border-0" tabIndex={0} aria-controls="empoloyees-tblwrapper" type="button"><span><i className="fa-solid fa-file-excel" /> Download Retailer</span></button> </div> */}
                                       <table id="table-to-xls" className="table dataTable no-footer" role="grid" aria-describedby="empoloyees-tblwrapper_info">
                                       <thead>
                                            <tr>
                                            {[
    { key: "s_no", label: "S.No" },
    { key: "createdAt", label: "Date" },
    { key: "order_id", label: "Order ID" },
    { key: "txn_id", label: "Transaction ID" },
    { key: "o_bal", label: "Opening Balance" },
    { key: "amount", label: "Amount" },
    { key: "c_bal", label: "Closing Balance" },
    { key: "type", label: "Type" },
    apes === false ? { key: "trans_type", label: "Transaction Type" } : null,
    { key: "message", label: "Message" }
].filter(Boolean).map(({ key, label }) => (
                                                    <th
                                                        key={key}
                                                        className={`${sortColumn === key ? (sortOrder === "asc" ? "sorting_asc" : "sorting_desc") : ""}`}
                                                        onClick={() => handleSort(key)}
                                                        tabIndex={0}
                                                        aria-controls="employees-tblwrapper"
                                                        rowSpan={1}
                                                        colSpan={1}
                                                        aria-sort={sortColumn === key ? (sortOrder === "asc" ? "ascending" : "descending") : "none"}
                                                        style={{ width: "150px", cursor: "pointer" }}
                                                    >
                                                        {label?.toUpperCase()} 
                                                        {/* {sortColumn === key ? (sortOrder === "asc" ? "↑" : "↓") : ""} */}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>

                                            <tbody>
                                                {sortedData && sortedData?.map((item,index) => {
                                                    return <tr role="row" className="odd" key={item?._id}>
                                                         <td ><span>{(page*10) + (index + 1)}</span></td>
                                                        <td className="sorting_1"><span>{item?.createdAt}</span></td>
                                                        <td className="sorting_1"><span>{item?.order_id || ''}</span></td>
                                                        <td>
                                                            {item?.txn_id}
                                                        </td>
                                                        
                                                        <td>

{item?.o_bal}
</td>
<td>{item?.amount}</td>
<td>
    {item?.c_bal}
</td>
<td>
    {item?.type}
</td>


                                                       { apes ===false &&  <td>{item?.trans_type}</td> }
                                                        <td>
                                                            {item?.message}
                                                        </td>
                                                       




                                                        {/* <td>
                                                            <span className="badge badge-success light border-0">{item?.approve.toString()}</span>
                                                        </td> */}
                                                        {/* <td>

                                                        </td> */}
                                                    </tr>
                                                })}

                                            </tbody>
                                        </table>
                                        < div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                            Total {totalCount} entries
                                        </div>
                                        <div className="dataTables_paginate paging_simple_numbers" id="empoloyees-tblwrapper_paginate">
                                            <Pagination
                                                // showSizeChanger
                                                // onShowSizeChange={''}

                                                // defaultCurrent={1}
                                                current={page+1}
                                                onChange={onChangeVal}
                                                total={totalCount}
                                            />
                                        </div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >

            </section>
        </>
    )
}
export default WalletsReportsList